import { createFileRoute } from "@tanstack/react-router";
import { useResetAtom } from "jotai/utils";
import { useEffect, type JSX } from "react";

import Confetti from "@repo/icons/colored/Confetti";

import doctorWithPatients from "@/assets/doctor-with-patients.png";
import { Button } from "@/components/ui/button/button";
import { ImageDrawerLayout } from "@/components/ui/layout/image-drawer/image-drawer-layout";
import { useReturnToNavigation } from "@/hooks/use-return-to-navigation";
import { firstAccessAtom } from "@/lib/atoms/first-access-atom";
import { trackFirstAccessCompleted } from "@/lib/auth/auth-tracking";

const FirstAccessCompletePage = (): JSX.Element => {
  const resetFirstAccess = useResetAtom(firstAccessAtom);
  const { navigateToReturnToOrFallback } = useReturnToNavigation();

  useEffect(() => {
    trackFirstAccessCompleted();
  }, []);

  const handleAction = (): void => {
    resetFirstAccess();
    navigateToReturnToOrFallback("/home");
  };

  return (
    <ImageDrawerLayout>
      <ImageDrawerLayout.Image>
        <img
          src={doctorWithPatients}
          alt="Médica em consultório com pacientes"
          className="object-top"
        />
      </ImageDrawerLayout.Image>

      <ImageDrawerLayout.Drawer>
        <Confetti size={80} className="fill-primary-400" aria-hidden="true" />

        <ImageDrawerLayout.Content>
          <ImageDrawerLayout.Title>Cadastro concluído!</ImageDrawerLayout.Title>
          <ImageDrawerLayout.Description>
            Bem-vindo à Livance. Seu consultório está pronto para começar.
          </ImageDrawerLayout.Description>
        </ImageDrawerLayout.Content>

        <Button fullWidth color="secondary" onClick={handleAction}>
          Acessar o app
        </Button>
      </ImageDrawerLayout.Drawer>
    </ImageDrawerLayout>
  );
};

export const Route = createFileRoute("/auth/first-access/complete")({
  component: FirstAccessCompletePage,
});
